'use client';

// react
import { useEffect, useState } from 'react';
// @mui
import { Box, Card, Divider } from '@mui/material';
// components
import { Loading } from '@/components/common';
// services
import { ContentsService } from '@/services';
// hooks
import { useAuth } from '@/hooks';
//
import CommentsList from './CommentsList';
import CommentInput from './CommentInput';

//-----------------------------------------------------------------
export default function ContentComments({ contentId }) {
  const { user } = useAuth();
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      const { success, ...response } = await ContentsService.getComments(contentId);
      if (success) setComments(response.data);
      setLoading(false);
    };
    init();
  }, [contentId]);
  const addToComments = (comment) => {
    const tempComments = [...comments];
    tempComments.unshift(comment);
    setComments(tempComments);
  };
  const handleCreateComment = async (comment) => {
    const { data } = await ContentsService.postComments(contentId, comment);
    addToComments(data);
  };

  return (
    <Card
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        background: '#ffffff',
        border: '1px solid #e1e1e1',
        boxSizing: 'border-box',
        borderRadius: '20px',
        paddingX: '30px',
        outline: 'none',
      }}
    >
      {loading ? (
        <Box sx={{ height: '100%' }}>
          <Loading />
        </Box>
      ) : (
        <Box sx={{ display: 'flex', flexGrow: 1, flexDirection: 'column', height: '100%' }}>
          <CommentsList comments={comments} />
          <Divider />
          <CommentInput
            contentId={contentId}
            onCreate={handleCreateComment}
            disabled={!user}
            disabledMessage="Login to make comment"
          />
        </Box>
      )}
    </Card>
  );
}
